import { GET_INTEGRATION_CONTENT_TOOL } from './tool-names.js';

export function isIntegrationContentMcpToolName(name: string): boolean {
  return name === GET_INTEGRATION_CONTENT_TOOL;
}

export { callIntegrationContentMcpTool } from './call-integration-content-mcp-tool.js';
export { INTEGRATION_CONTENT_MCP_TOOL_DEFINITIONS } from './tool-definitions.js';
export { GET_INTEGRATION_CONTENT_TOOL } from './tool-names.js';
